import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=35b56984&"
import script from "./EventList.vue?vue&type=script&lang=js&"
export * from "./EventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b56984')) {
      api.createRecord('35b56984', component.options)
    } else {
      api.reload('35b56984', component.options)
    }
    module.hot.accept("./EventList.vue?vue&type=template&id=35b56984&", function () {
      api.rerender('35b56984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Event/EventList/EventList.vue"
export default component.exports